import { call, put, select } from "redux-saga/effects";
import cirrusClient from "../../../services/api/cirrus-client";
import { setDomainInfoLoading, setDomainInfo } from "../../../state/callCenter/domainInfoSlice";
import { selectUserCredentials } from "../../../state/userCredential/userCredentialSlice";

export function* fetchDomainInfoSaga() {
    try {
        yield put(setDomainInfoLoading(true));

        const { domain } = yield select(selectUserCredentials);
        const apiUrl = '?object=domain&action=read&format=json'
        const params = {
            domain: domain,
            billing: 'yes',
        };

        const response = yield call(cirrusClient.get, apiUrl, { params })
        yield put (setDomainInfo(response.data))

    } catch (error) {
        console.error('Error fetching domain info', error)

    }

}